function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6276 88.61C11.1676 88.61 10.6976 88.57 10.2376 88.48C6.16761 87.71 3.48761 83.78 4.25761 79.72L10.7476 45.51H7.49761C6.77761 45.51 6.06761 45.41 5.37761 45.2C1.40761 44.02 -0.862386 39.84 0.307614 35.89L9.37761 5.36C10.3176 2.2 13.2676 0 16.5676 0C34.9343 0.0133333 44.5476 0.193333 45.4076 0.54C47.6376 1.44 49.2476 3.27 49.8576 5.55C50.2776 7.13 50.1776 8.82 49.5676 10.31L42.6476 27.41C44.1276 27.41 45.5576 27.86 46.7876 28.68C48.4476 29.79 49.5776 31.49 49.9676 33.46C50.3576 35.42 49.9576 37.42 48.8376 39.08L17.8476 85.29C16.4576 87.37 14.1276 88.61 11.6176 88.61H11.6276Z",
  fill: "#FFD417"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.51763 38.8002H18.8576L10.8576 80.9702C10.7776 81.4002 11.0576 81.8202 11.4876 81.9002C11.7976 81.9602 12.1176 81.8302 12.2976 81.5602L43.2876 35.3502C43.5276 34.9902 43.4376 34.4902 43.0676 34.2502C42.9376 34.1602 42.7876 34.1202 42.6276 34.1202H32.7176L43.3576 7.7902C43.4576 7.5502 43.4676 6.9802 42.9176 6.7602C42.8276 6.7202 16.5676 6.7002 16.5676 6.7002C16.2176 6.7002 15.9076 6.9302 15.8076 7.2702L6.74763 37.7802C6.62763 38.2002 6.86763 38.6402 7.28763 38.7702C7.35763 38.7902 7.43763 38.8002 7.51763 38.8002V38.8002Z",
  stroke: "#111927",
  strokeWidth: 1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgIconLightning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 51 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightning);
export default __webpack_public_path__ + "static/media/icon-lightning.14d5a803.svg";
export { ForwardRef as ReactComponent };